import React, { useState, useEffect, useImperativeHandle } from "react";
import { getRequestOptions } from "../components/GetToken";
import AsyncSelect from "react-select/async";
import Radio from "@mui/material/Radio";

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: "calc(1.35em + 1.1rem + 2px)",
        minHeight: "35px",
    }),
};

const VehicleAssign = React.forwardRef(({ vehicleAssignEditData, vehicleInfo, onVehicleAssignChange }, ref) => {
    const initialState = {
        project: "",
        driver: "",
        payrollUser: "yes",
        consultantOrAdvisorName: "",
        consultantOrAdvisorDesignation: "",
        assignedUser: "",
        selfDriven: "no"
    };

    const [vehicleAssign, setVehicleAssign] = useState(initialState);
    const [fieldStatus, setFieldStatus] = useState(false);

    useImperativeHandle(ref, () => ({
        setInitialState: () => setVehicleAssign(initialState),
    }));

    useEffect(() => {
        if (vehicleAssignEditData) {
            setVehicleAssign(vehicleAssignEditData);
            setFieldStatus(true);
        } else {
            setFieldStatus(false);
        }
    }, [vehicleAssignEditData]);

    useEffect(() => {
        onVehicleAssignChange(vehicleAssign);
    }, [vehicleAssign, onVehicleAssignChange]);

    const getAllProject = (inputValue, callback) => {

        if (!inputValue) {
            callback([]);

        }
        else {
            var url = process.env.REACT_APP_API_URL + "getBusinessUnits?q=" + inputValue;

            setTimeout(() => {
                fetch(url,
                    getRequestOptions())

                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = element.projectName;
                            element.value = element.projectId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const getAllDriver = (inputValue, callback) => {

        if (!inputValue) {
            callback([]);

        }
        else {
            var url = process.env.REACT_APP_API_URL + "getAllDriver?q=" + inputValue;

            setTimeout(() => {
                fetch(url,
                    getRequestOptions())

                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.fullName} (${element.mobileNumber})`;
                            element.value = element.idVmsDrivers;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const getUserForAssign = (inputValue, callback) => {

        if (!inputValue) {
            callback([]);

        }
        else {
            var url = process.env.REACT_APP_API_URL + "users/getUserForAssign?q=" + inputValue;

            setTimeout(() => {
                fetch(url,
                    getRequestOptions())

                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.fullName} (${element.designation})`;
                            element.value = element.employeeId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    const handleProjectChange = businessUnit => {
        setVehicleAssign({ ...vehicleAssign, project: businessUnit });
    }

    const handlePayrollUserChange = evt => {
        setVehicleAssign({ ...vehicleAssign, payrollUser: evt.target.value });
    }

    const handleAssignedUserChange = user => {
        setVehicleAssign({ ...vehicleAssign, assignedUser: user });
    }

    const handleDriverChange = driver => {
        setVehicleAssign({ ...vehicleAssign, driver: driver });
    }

    return (
        <>
            <div className="form-group row">
                <label className="col-lg-3 col-form-label text-end">Project Name</label>
                <div className="col-lg-5">
                    <AsyncSelect
                        isDisabled={fieldStatus}
                        value={vehicleAssign.project}
                        loadOptions={getAllProject}
                        placeholder="Select Project"
                        onChange={handleProjectChange}
                        styles={customStylesSelect}
                    />
                </div>
            </div>

            <div className="form-group row">
                <label className="col-lg-3 col-form-label text-end">Payroll User</label>
                <div className="col-lg-5">
                    <select
                        className="form-select form-select-sm"
                        value={vehicleAssign.payrollUser}
                        onChange={handlePayrollUserChange}
                    >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
            </div>

            {vehicleAssign.payrollUser === "yes" ? (
                <div className="form-group row">
                    <label className="col-lg-3 col-form-label text-end">
                        Assign To User {vehicleInfo?.vehicleType?.idVehicleType === 14 && <span className="text-danger">*</span>}
                    </label>
                    <div className="col-lg-5">
                        <AsyncSelect
                            value={vehicleAssign.assignedUser}
                            loadOptions={getUserForAssign}
                            placeholder="Select User"
                            onChange={handleAssignedUserChange}
                            styles={customStylesSelect}
                        />
                    </div>
                </div>
            ) : (
                <>
                    <div className="form-group row">
                        <label className="col-lg-3 col-form-label text-end">Consultant / Advisor's Name</label>
                        <div className="col-lg-5">
                            <input
                                type="text"
                                name="consultantOrAdvisorName"
                                value={vehicleAssign.consultantOrAdvisorName}
                                onChange={(e) => { setVehicleAssign({ ...vehicleAssign, consultantOrAdvisorName: e.target.value }) }}
                                className="form-control form-control-sm"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-lg-3 col-form-label text-end">Designation</label>
                        <div className="col-lg-5">
                            <input
                                type="text"
                                name="consultantOrAdvisorDesignation"
                                value={vehicleAssign.consultantOrAdvisorDesignation}
                                onChange={(e) => { setVehicleAssign({ ...vehicleAssign, consultantOrAdvisorDesignation: e.target.value }) }}
                                className="form-control form-control-sm"
                            />
                        </div>
                    </div>
                </>
            )}
            <div className="form-group row">
                <label className="col-lg-3 col-form-label text-end">Self Driven <span className="text-danger">*</span></label>
                <div className="col-lg-5">
                    {["no", "yes"].map((option) => (
                        <label key={option} className="me-3">
                            <Radio
                                checked={vehicleAssign.selfDriven === option}
                                onClick={() => setVehicleAssign((prev) => ({ ...prev, selfDriven: option }))}
                                value={option}
                                name="selfDriven"
                            />
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                        </label>
                    ))}
                </div>
            </div>
            {vehicleAssign.selfDriven === "no" && vehicleInfo?.vehicleType?.idVehicleType !== 14 && (
                <div className="form-group row">
                    <label className="col-lg-3 col-form-label text-end">
                        Driver Name
                    </label>
                    <div className="col-lg-5">
                        <AsyncSelect
                            value={vehicleAssign.driver}
                            loadOptions={getAllDriver}
                            placeholder="Select Driver"
                            onChange={handleDriverChange}
                            styles={customStylesSelect}
                        />
                    </div>
                </div>
            )}
            {/* <pre>{JSON.stringify(vehicleAssign, null, 2)}</pre> */}
        </>
    );
});

export default React.memo(VehicleAssign);
